/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CardStateListResponse } from '../models/CardStateListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CardStateService {
  /**
   * Get card possible states
   * @returns CardStateListResponse
   * @throws ApiError
   */
  public static cardStateControllerGetAll(): CancelablePromise<CardStateListResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/public/card-states',
      errors: {
        401: `User wasn't authenticated.`,
        403: `User didn't have permissions to perform this action.`,
        500: `Something went wrong.`,
      },
    });
  }
}
